import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { useSubscriptionsApi } from './use-subscriptions'

export function useGetMySubscription() {
  const { getMySubscription } = useSubscriptionsApi()

  return useQuery({
    queryKey: ['my-subscription'],
    queryFn: () => getMySubscription(),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    staleTime: 1000 * 30,
  })
}
